import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import { styles } from './styles';
import { useCurrentDataset } from '../../hooks/useCurrentDataset';
import AppBar from '@components/common/AppBar';
import { Modals } from '@core/Modal';
import { registeredModals } from '@components/modals/registeredModals';
import SuspenseLoading from '@components/common/SuspenseLoading';

export type MetametricsCardLayoutProps = {};

const MetametricsCardLayout: React.FC<MetametricsCardLayoutProps> = () => {
  useCurrentDataset();

  return (
    <Box sx={styles.root}>
      <AppBar isBackground={false} />
      <Modals registeredModals={registeredModals} />
      <Suspense fallback={<SuspenseLoading />}>
        <Box sx={styles.wrapper}>
          <Outlet />
        </Box>
      </Suspense>
    </Box>
  );
};

export default MetametricsCardLayout;
